import React from 'react';
import { Link } from 'react-router-dom';
import { ArrowRight } from 'lucide-react';
import { firstSplashPhotos } from '../data/mock';
import { privateLessons as pl } from '../data/programDetails';
import StackedHero from '../components/programs/StackedHero';
import ProgramFaq from '../components/programs/ProgramFaq';

const photo = firstSplashPhotos.gallery[1];

export default function PrivateLessons() {
  return (
    <main data-testid="private-lessons-page">
      <StackedHero image={photo.src} alt="Coach smiling with a young swimmer during a one-on-one lesson" position="center 50%" eyebrow="All Ages · 1:1 and 2:1" title="Private & Semi-Private Lessons">
        <p className="mt-6 text-splash-green/80 text-lg leading-relaxed">Fully personalized lessons for swimmers who need focused attention, a faster pace, or a calmer environment — with a plan built around your child.</p>
        <div className="mt-8 grid sm:grid-cols-2 gap-4">
          {pl.options.map((o) => (
            <div key={o.id} data-testid={`private-option-${o.id}`} className="rounded-3xl bg-white border border-splash-sand p-6">
              <h2 className="font-display font-bold text-2xl text-splash-green">{o.title}</h2>
              <p className="mt-2 text-splash-green/80">{o.body}</p>
            </div>
          ))}
        </div>
        <p className="mt-6 text-splash-green/75">{pl.note}</p>
        <Link to="/contact" data-testid="private-check-availability-btn" className="inline-flex items-center gap-2 mt-6 mb-8 rounded-full bg-splash-coral hover:bg-splash-coralDark text-white px-7 py-3.5 font-semibold btn-transition">
          Check availability <ArrowRight className="w-4 h-4" />
        </Link>
      </StackedHero>
      <ProgramFaq items={pl.faq} title="Private & Semi-Private FAQ" testId="private-faq" />
    </main>
  );
}
